import React, { useRef } from "react";
import { useHistory } from "react-router-dom";

import classes from "./Search.module.css";
import { BsSearch } from "react-icons/bs";

const Search = (props) => {
  const history = useHistory();
  const searchRef = useRef();

  const searchInputHandler = (event) => {
    event.preventDefault();
    const query = searchRef.current.value;
    history.push(`/search?query=${query}`);
  };
  const classValue = props.search === "nav";

  return (
    <form onSubmit={searchInputHandler} className={`${classes.form} ${classValue? "" :classes[`banner-form`]}`} >
      <input
        className={
          classValue ? classes[`nav-searchbar`] : classes[`banner-searchbar`]
        }
        type="text"
        ref={searchRef}
        placeholder="Search for free images"
      />
      <button
        className={`${classes[`search-button`]} ${
          classValue ? classes.nav : classes.banner
        }`}
        type="submit"
      >
        <BsSearch size={props.size} />
      </button>
    </form>
  );
};

export default Search;
